// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referral-service-type-select .choices__list{max-height:500px}.referral-service-type-select .choices__list--dropdown .choices__list:last-child{padding-bottom:3em}", ""]);
// Exports
module.exports = exports;
